export const CheckboxStyles = {
  variants: {
    base: {
      control: {
        borderColor: "main_text_color",

        _checked: {
          borderColor: "primary",
          backgroundColor: "primary",
        },
      },

      icon: {
        color: "white",
      },
    },
  },

  sizes: {
    base: {
      control: {
        width: "15px",
        height: "15px",
      },
    },
  },
}
